


const LandingPageSplash = () => {

    return (
        <div className='flex flex-col bg-gray-900 justify-center items-center h-screen'>
            <div className='flex flex-col items-center relative'>
                <img src="/bnty.png" alt="logo" className='w-[90%] md:w-[50%] lg:w-[50%]' />
                <p className='text-stone-300 absolute bottom-10 sm:bottom-16 md:bottom-10'>"Connect. Train. Grow."</p>
            </div>
        </div>
    )
}

export default LandingPageSplash
